////////////////////////////////////////////////////////////////////////////////
// Search
////////////////////////////////////////////////////////////////////////////////

class Search {

	constructor(searchComponents) {

    this.searchComponents = searchComponents;
    this.bindEvents();

	}

  bindEvents(){

    const { input, form, suggestions } = this.searchComponents;

    input.on('input', event => {
      const value = $(event.currentTarget).val();
      this.autosuggest(value);
    });

		input.on('blur', event => {
			setTimeout(() => {
				suggestions.html('')
			}, 500)
		});

		input.on('focus', event => {
			suggestions.html('')
			const value = $(event.currentTarget).val();
			if ( value !== '' ) {
				this.autosuggest(value);
			}
		});

    form.on('submit', event => {
      event.preventDefault();
    });

  }

  autosuggest(value){

    const data = { term: value, siteId: document.documentElement.dataset.localeId || 1 };

    fetch('/api/suggestions', { method: "POST", body:JSON.stringify(data) })
      .then(res => res.json())
      .then(data => this.renderSuggestions(data.data));

  }

  renderSuggestions(data) {

    const { suggestions } = this.searchComponents;

    if(data.entries.length === 0){
      suggestions.html('');
      return false;
    }

    const resultsTemplate = data.entries.map(entry => {
      return `<a href="/${entry.uri}">${entry.title}</a>`;
    });

    suggestions.html(resultsTemplate);

  }

}
